import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

export const useCriteriaStoreUpdatePredicate = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const updatePredicate = useStore(store, (s) => s.updatePredicate);

    return updatePredicate;
};
